// Nextsj blog
import React, {  useEffect } from 'react';
import { createClient } from '../../prismicio';
import { Mixpanel } from 'utils/mixpanel';
import AllBlogs from 'containers/SaasModern/Blog/AllBlogs';
import { getPrismicLanguage } from 'utils/getPrismicLanguage';
import Page from 'containers/SaasModern/Page';
import MetaHead from 'common/components/MetaHead';

export default function Blogs({ data, data_main, articleTags, locale }) {
  useEffect(() => {
    Mixpanel.track('Blog view', {
      'Blog title': 'Blog',
    });
  }, []);
  return (
    <Page locale={locale}>
      <MetaHead
        title={data_main?.data?.meta_title}
        description={data_main?.data?.meta_description}
        keywords={data_main?.data?.meta_keywords}
        imageUrl={data_main?.data?.meta_image?.url}
      />
      <AllBlogs data={data} data_main={data_main} articleTags={articleTags} />
    </Page>
  );
}

export const getStaticProps = async ({ locale }) => {
  const client = createClient();
  const prismicLanguage = getPrismicLanguage(locale);

  // Récupérer tous les articles
  const data = await client.getAllByType('article', {
    lang: prismicLanguage,
    orderings: [{ field: 'my.article.published_date', direction: 'desc' }],
  });

  // Récupérer tous les tags
  const article_tags = await client.getAllByType('article_tags', {
    lang: prismicLanguage,
    orderings: [{ field: 'my.article_tags.title', direction: 'desc' }],
  });

  // Récupérer la page principale
  const data_main = await client.getSingle('blog_list_main_page', {
    lang: prismicLanguage,
  });

  // Pour chaque tag, trouver dynamiquement les catégories associées via les articles
  const articleTagsWithCategories = article_tags.map((tag) => {
    const articlesWithTag = data.filter(
      (article) =>
        Array.isArray(article.data.article_tags) &&
        article.data.article_tags.some(
          (t) => t && t.article_tag && t.article_tag.uid === tag.uid,
        ),
    );
    const categoriesForTag = articlesWithTag
      .map((article) => article.data.category)
      .filter((cat) => cat && cat.id && cat.data && cat.data.name);
    // Retirer les doublons
    const seen = new Set();
    const uniqueCategories = categoriesForTag.filter((cat) => {
      if (seen.has(cat.id)) return false;
      seen.add(cat.id);
      return true;
    });
    return {
      ...tag,
      categories: uniqueCategories,
    };
  });

  return {
    props: {
      data: data || [],
      data_main: data_main || { data: null },
      articleTags: articleTagsWithCategories,
      locale,
    },
  };
};
